import { FC, useState } from "react";
import click from "../../../assets/images/click.svg";
import trade from "../../../assets/images/trade.svg";
import cash_icon from "../../../assets/images/cash_icon.svg";
import {
  getProductIcons,
  getProductInactiveIcons,
} from "../../../helpers/get-currency-number";
import wallet from "../../../assets/images/wallet.svg";

const TabsList: FC<{
  data: Array<{
    label: string;
    value: string;
    icon?: boolean;
    walletIcon?: boolean;
  }>;
  onChange: (tab: { label: string; value: string }, i: number) => void;
  activeTab?: string;
  className?: string;
}> = ({ data, onChange, activeTab, className }) => {
  const handleClick = (tab: { label: string; value: string }, i: number) => {
    onChange(tab, i);
  };
  return (
    <>
      <ul
        className={`flex overflow-x-auto md:overflow-x-none gap-4 ${className}`}
        id="scroll_style"
      >
        {data.map((tab, i) => (
          <li
            key={`tab-${i}`}
            className={`cursor-pointer whitespace-nowrap px-2 py-3 fs-12 rounded-t-lg font-semibold ${
              activeTab === tab.value
                ? "color-primary active_border"
                : " color-sub-text"
            }`}
            style={{ fontWeight: 700, fontSize: "12px" }}
            onClick={(e) => {
              e.preventDefault();
              handleClick(tab, i);
            }}
          >
            <div
              className={`flex ${
                tab.icon || tab.walletIcon ? "gap-1" : ""
              } items-center font-semibold`}
            >
              {tab.icon ? (
                <img
                  src={
                    activeTab === tab.value
                      ? getProductIcons(tab.value.toUpperCase())
                      : getProductInactiveIcons(tab.value.toUpperCase())
                  }
                  className={` ${activeTab === tab.value ? "w-4" : "w-5"}`}
                />
              ) : tab?.walletIcon ? (
                <img
                  src={wallet}
                  className={` ${activeTab === tab.value ? "w-4" : "w-5"}`}
                />
              ) : (
                ""
              )}
              {tab.label}
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
export default TabsList;
